<template>
  <div>
    <div class="searchBlock" v-if="isDynamic">
      <el-divider content-position="left">二维表搜索配置</el-divider>
      <el-form-item label="可搜索">
        <el-switch v-model="data.isSearch"></el-switch>
      </el-form-item>
      <el-form-item v-if="data.isSearch" label="搜索方式">
        <el-radio-group v-model="data.searchWay" size="small">
          <el-radio-button label="equal">精确</el-radio-button>
          <el-radio-button label="like">模糊</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </div>
    <!-- 扩展 字段采集 开始 -->
      <el-form-item label="采集资源:" v-if="!isDynamic">
        <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：" >
            <el-option
            v-for="item in resource"
            :key="item.resourceId"
            :label="item.tableComment"
            :value="item.resourceId">
            </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="采集字段:">
        <el-select clearable v-model="data.fieldName" placeholder="请选择采集字段">
            <el-option
            v-for="item in field"
            :key="item.columnName"
            :label="item.columnComment"
            :value="item.columnName">
            </el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="是否回填：" v-if="!isDynamic">
        <el-switch v-model="data.writable"></el-switch>
      </el-form-item>
      <!-- 扩展 字段采集 结束 -->
    <el-form-item label="字体颜色">
      <avue-color v-model="data.color"></avue-color>
    </el-form-item>
    <el-form-item label="加粗">
      <el-switch v-model="data.fontWeight"></el-switch>
    </el-form-item>
    <el-form-item label="占位内容">
      <el-input v-model="data.placeholder"
                placeholder="占位内容"></el-input>
    </el-form-item>
    <el-form-item label="默认值">
      <el-input v-model="data.value"
                placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="最大长度">
      <el-input-number v-model="data.maxlength"
                       controls-position="right"
                       placeholder="最大长度"></el-input-number>
    </el-form-item>
    <el-form-item label="显示计数">
      <el-switch v-model="data.showWordLimit"></el-switch>
    </el-form-item>
    <el-form-item label="最小行">
      <el-input-number v-model="data.minRows"
                       controls-position="right"
                       placeholder="最小行"
                       :min="1"></el-input-number>
    </el-form-item>
    <el-form-item label="最大行">
      <el-input-number v-model="data.maxRows"
                       controls-position="right"
                       placeholder="最大行"
                       :min="2"></el-input-number>
    </el-form-item>
    <el-form-item label="是否只读">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item>
    <el-form-item label="悬浮提示" v-if="isDynamic">
      <el-switch v-model="data.showTip"></el-switch>
    </el-form-item>
    <el-form-item label="可展开" v-if="isDynamic">
      <el-switch v-model="data.isExpand"></el-switch>
    </el-form-item>

    <el-form-item label="正则校验">
      <el-input v-model.lazy="data.pattern"
                placeholder="正则表达式"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import mixinIsDynamic from '../../mixins/isDynamic'
export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigTextarea',
  props: ['data', 'widgetForm'],
  data() {
    return {
      resource: [],
      field: [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      }
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    }
  },
  watch: {
    'data.resourceId': function(val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `${this.data.label}必须填写` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.pattern': function(val) {
      if (val) this.validator.pattern = { pattern: val, message: `${this.data.label}格式不匹配` }
      else this.validator.pattern = null

      // delete this.data.pattern
      this.generateRule()
    }
  }
}
</script>

<style scoped>
@import './search.scss';
</style>
